export default {
  workExperienceItem: {
    job_title: null,
    employer: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null,
    isCurrent: false
  },
  workExperienceList: [],
  workExperienceErrorList: [],
  workExperienceErrorItem: {
    job_title: null,
    employer: null,
    start_year: null,
    start_month: null,
    end_year: null,
    end_month: null
  }
};
